import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

export default function SourceSelect({ value, handler }) {
  return (
    <FormControl size="small" sx={{ minWidth: 130, m: 1 }}>
      <InputLabel>Fonte</InputLabel>
      <Select
        value={value || ''}
        label="Fonte"
        onChange={(e) => handler(e.target.value || null)}
      >
        <MenuItem value="">Todos</MenuItem>
        <MenuItem value="zabbix">Zabbix</MenuItem>
        <MenuItem value="wazuh">Wazuh</MenuItem>
      </Select>
    </FormControl>
  )
}
